import html2canvas from 'html2canvas';
import jspdf from 'jspdf';

const pdfGenerator = {};

const screenToDoc = (callback) => {
    // take the largest resolution image to prevent blurriness
    let options = { scale: 2 };

    html2canvas(document.querySelector("#capture"), options).then(canvas => {
        // turn of any smoothing to prevent event more blurriness
        var context = canvas.getContext("2d");
        context.webkitImageSmoothingEnabled = false;
        context.mozImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;

        //compress the image so we don't get a massive pdf in the end
        var base64image = canvas.toDataURL("image/jpeg");

        // default to letter
        var doc = new jspdf("p", "mm", "letter");
        let height = doc.internal.pageSize.height;
        let width = doc.internal.pageSize.width;
        doc.addImage(base64image, 'jpeg', 0, 0, width, height);        

        callback(doc);
    });
}

pdfGenerator.createPdfBlob = (callback) => {    
    screenToDoc((screenDoc) => {
        const invoicePdf = screenDoc.output('blob');
        callback(invoicePdf);        
    });
}

pdfGenerator.createPdfFile = (filename) => {
    screenToDoc((screenDoc) => {
        screenDoc.save(filename);        
    });
}

export default pdfGenerator;